import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      borderRadius: 44,
      [theme.fn.smallerThan('sm')]: {
        width: '100%',
      },
    },
  }
})
